$(function() {
    if ($('.wheel360')[0]) {
        const numberBtn = '.wheel360__number';
        const contentItems = '.wheel360__content';

        let animating = false;

        $('body').on('mouseover', numberBtn, function() {
            const dataValue = $(this).data('item');

            update360Diagram($(this), contentItems, dataValue);
        });

        function update360Diagram(segment, contentItems, dataValue) {
            if (!segment.hasClass('active')) {
                segment
                    .addClass('active')
                    .siblings()
                    .removeClass('active');

                const targetItem = $(contentItems).filter(function() {
                    return $(this).data('item') === dataValue;
                });

                if (!animating) {
                    animating = true;

                    $('.wheel360__content.active')
                        .stop(true, true)
                        .fadeOut(300, function() {
                            $(this).removeClass('active');
                            animating = false;
                            targetItem.addClass('active').fadeIn(300);
                        });
                } else {
                    setTimeout(() => {
                        $('.wheel360__content.active')
                            .stop(true, true)
                            .fadeOut(300, function() {
                                $(this).removeClass('active');
                                animating = false;
                                targetItem.addClass('active').fadeIn(300);
                            });
                    }, 600);
                }
            }
        }
    }

    $(window).resize(function() {
        if (window.innerWidth < 1101) {
            $('.wheel360__number').removeClass('active');
            $('.wheel360__number:first-child').addClass('active');
            $('.wheel360__content').removeAttr('style');
        }
    });
});
